export default __webpack_public_path__ + "static/media/Anil.bca8252c.jpg";